<template>
    <div v-if="!hide" class="form-network form-network-tiktok">
       <details open>
           <summary>{{ $t('dash.post-creator.form.tiktok.privacy') }} <i class="fa-solid fa-caret-down"></i></summary>
           <div class="content-detail">
                <SelectComponent :valueSelect="formDataNetwork.visibility" :changeValueSelect="changeVisibilityPost" :data="{all:$t('dash.post-creator.form.tiktok.visibility-public'), friends:$t('dash.post-creator.form.tiktok.visibility-friends'),me:$t('dash.post-creator.form.tiktok.visibility-me')}"  :positionAuto="false" :positionX="'left'"></SelectComponent>
                <div class="list-simple-btn" v-if="hasVideo && nativeMode">
                    <div class="type-btn-simple" @click="addMode('addTiktokMusicMode')">
                        <i class="fa-solid fa-music"></i>
                        <p>Musique <span class="pink">({{ formDataNetwork.music ? '1' : '0' }})</span></p>
                    </div>
                </div>
                <div class="type-switch">
                        {{ $t('dash.post-creator.form.tiktok.disable-comments') }}
                    <ComponentSwitch :value="formDataNetwork.commentDisable" :onChange="(v)=> formDataNetwork.commentDisable = v" :id="'switch-settings-advanced-tiktok-1'"></ComponentSwitch>
                </div>
                <div v-if="hasVideo" class="type-switch">
                        {{ $t('dash.post-creator.form.tiktok.allow-duo') }}
                    <ComponentSwitch :value="formDataNetwork.useVideoForDuo" :onChange="(v)=>{formDataNetwork.useVideoForDuo = v}" :id="'switch-settings-advanced-tiktok-2'"></ComponentSwitch>
                </div>
                <div v-if="hasVideo" class="type-switch">
                        {{ $t('dash.post-creator.form.tiktok.allow-stitch') }}
                    <ComponentSwitch :value="formDataNetwork.useVideoForOtherVideo" :onChange="(v)=>{formDataNetwork.useVideoForOtherVideo = v}" :id="'switch-settings-advanced-tiktok-3'"></ComponentSwitch>
                </div>
                <div v-if="hasPhotos" class="type-switch">
                        {{ $t('dash.post-creator.form.tiktok.auto-music') }}
                    <ComponentSwitch :value="formDataNetwork.autoAddMusic" :onChange="(v)=>{formDataNetwork.autoAddMusic = v}" :id="'switch-settings-advanced-tiktok-4'"></ComponentSwitch>
                </div>
                <div class="type-switch">
                        {{ $t('dash.post-creator.form.tiktok.brand-content') }}
                    <ComponentSwitch :value="formDataNetwork.brandContentToggle" :onChange="(v)=>{formDataNetwork.brandContentToggle = v}" :id="'switch-settings-advanced-tiktok-5'"></ComponentSwitch>
                </div>
                <div class="type-switch">
                        {{ $t('dash.post-creator.form.tiktok.brand-organic') }}
                    <ComponentSwitch :value="formDataNetwork.brandOrganicToggle" :onChange="(v)=>{formDataNetwork.brandOrganicToggle = v}" :id="'switch-settings-advanced-tiktok-6'"></ComponentSwitch>
                </div>
                <div v-if="hasVideo" class="type-switch">
                        {{ $t('dash.post-creator.form.tiktok.ai-generated') }}
                    <ComponentSwitch :value="formDataNetwork.isAigc" :onChange="(v)=>{formDataNetwork.isAigc = v}" :id="'switch-settings-advanced-tiktok-7'"></ComponentSwitch>
                </div>
           </div>
       </details>
   </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import store from '@/store/index.js';
    import ComponentSwitch from '@/components/dash/utils/switch.vue'
    import SelectComponent from '@/components/dash/utils/select.vue'
    import SnippetNetwork from './../SnippetNetwork.vue'
    import minxinBot from '@/components/mixins/Bots.vue'
    import minxinPost from '@/components/mixins/Posts.vue'
    export default {

       components: {
           ComponentSwitch,
           SnippetNetwork,
           SelectComponent
       },
       mixins: [minxinBot,minxinPost],

       props: {
           hide : {
               type: Boolean,
               default: false
           },
           formData: {
               type: Object,
               default: () => ({})
           },

           formDataNetwork: {
               type: Object,
               default: () => ({})
           },

           files: {
               type: Object,
               default: () => ({})
           },
       },

       data() {
           return {
               inputModel:{

               },

               lastModeSelected : undefined
           }
       },

       
       mounted() {
            EventBus.$on('eventClickSelectTiktokMusic', this.addMusic)
            EventBus.$on('eventRemoveSelectTiktokMusic', this.removeMusic)
            if (this.formData.formDataNetwork.tiktok) this.formDataNetwork = this.formData.formDataNetwork.tiktok
       },

       methods: {
           addMode(mode) {
               this.lastModeSelected = mode
               EventBus.$emit("postCreatorAddMode", mode);
           },
           changeVisibilityPost(state) {
                this.formDataNetwork.visibility = state
                this.$emit('setFormDataNetwork', 'tiktok', this.formDataNetwork)
            },
            addMusic(music) {
                this.$set(this.formDataNetwork, 'music', music)
                this.$emit('setFormDataNetwork', 'tiktok', this.formDataNetwork)
            },
            removeMusic() {
                this.$set(this.formDataNetwork, 'music', undefined)
                this.$emit('setFormDataNetwork', 'tiktok', this.formDataNetwork)
            },
        },
        
        computed: {
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
            },

            hasVideo() {
                if (!this.formData || !this.formData.files) return false;
                return this.formData.files.some(fileRef => {
                    const file = this.files[fileRef.id];
                    return file && file.info && file.info.type2 === 'video';
                });
            },

            hasPhotos() {
                if (!this.formData || !this.formData.files) return false;
                return this.formData.files.some(fileRef => {
                    const file = this.files[fileRef.id];
                    return file && file.info && file.info.type2 === 'image';
                });
            },

            nativeMode() {
                return this.pagesSelected.some(p => p && p.network === 'tiktok' && p.story_config && p.story_config.created)
            },

       },

       watch: {

           ['formData.formDataNetwork.tiktok']() {
                if (this.formData.formDataNetwork.tiktok) this.formDataNetwork = this.formData.formDataNetwork.tiktok
            },
       },

       beforeDestroy () {
           EventBus.$off('eventClickSelectTiktokMusic', this.addMusic)
           EventBus.$off('eventRemoveSelectTiktokMusic', this.removeMusic)
       }
       
   }
</script>
